<app-top-nav  class="mat-elevation-z6"></app-top-nav>
<router-outlet [class.has-tabs]="hasTabs"></router-outlet>
<xui-toasts></xui-toasts>
<ui-draft-overlay-draggable></ui-draft-overlay-draggable>
@if (isLocked) {
  <xui-lock (login)="startIdleTimer()" (logout)="logout()"></xui-lock>
}
